export default {
  UPDATE_UPCOMING_VISITS: 'CALENDAR.UPDATE_UPCOMING_VISITS',
  FETCH_UPCOMING_VISITS_START: 'CALENDAR.FETCH_UPCOMING_VISITS_START',
  FETCH_UPCOMING_VISITS_FAILURE: 'CALENDAR.FETCH_UPCOMING_VISITS_FAILURE',
}
